/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { SEO } from '../components/common';
import { CategoryCard } from '../components/blog';
import { categories, blogPosts } from '../data/blogPosts';
import { colors, typography } from '../styles/theme';

const pageStyles = css`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;

  @media (min-width: 768px) {
    padding: 3rem 2rem;
  }
`;

const headerStyles = css`
  text-align: center;
  margin-bottom: 3rem;

  h1 {
    font-family: ${typography.fontFamily.heading};
    font-size: ${typography.fontSize['3xl']};
    color: ${colors.text.primary};
    margin-bottom: 0.75rem;

    @media (min-width: 768px) {
      font-size: ${typography.fontSize['4xl']};
    }
  }

  p {
    color: ${colors.text.secondary};
    font-size: ${typography.fontSize.lg};
    max-width: 600px;
    margin: 0 auto;
  }
`;

const gridStyles = css`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export default function CategoriesPage() {
  const categoryPostCounts = categories.reduce((acc, cat) => {
    acc[cat.id] = blogPosts.filter(p => p.category.id === cat.id).length;
    return acc;
  }, {} as Record<string, number>);

  return (
    <>
      <SEO
        title="Kategoriler"
        description="Çekici, yol yardım, nakliye, vinç hizmetleri ve daha fazlası hakkında kategorilere göre blog yazıları."
        url="/kategoriler"
      />

      <div css={pageStyles}>
        <header css={headerStyles}>
          <h1>Kategoriler</h1>
          <p>İlgilendiğiniz konuya göre blog yazılarını keşfedin</p>
        </header>

        <div css={gridStyles}>
          {categories.map(category => (
            <CategoryCard
              key={category.id}
              category={category}
              postCount={categoryPostCounts[category.id]}
            />
          ))}
        </div>
      </div>
    </>
  );
}
